import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import { ENTITY_TYPES, ROUTE_PATH, APP_PAGES } from '../../../../../../data/config/constants';
import { showMessage } from '../../../../../../data/config/utils';

import * as pageActions from '../../../../../../data/redux/page_details/actions';
import * as entityActions from '../../../../../../data/redux/entity_details/actions';

import PageHeaderLoader from '../../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../../components/loaders/cardrowtable';
import ErrorBoundary from '../../../../../../components/errorboundary';
import ShowMessage from '../../../../../../components/showmessage';
import SimpleEntity from './simpleentity';
import HierarchicalEntity from './hierarchicalentity';
import ListEntity from './listentity';

class EditEntity extends Component {
    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.ENTITIES, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        const { actions, match, history } = this.props;
        if (match && match.params && match.params.entityId && match.params.entityType) {
            const payload = {
                entityID: match.params.entityId,
                type: match.params.entityType
            };
            actions.getEntityData(payload);
        } else {
            history.push(ROUTE_PATH.ENTITIES);
            showMessage('error', 'route params are not valid');
        }
    }

    goToEntitiesPage = () => {
        const { history } = this.props;
        history.push(ROUTE_PATH.ENTITIES);
    };

    updateEntity = () => {
        const { entity_details, actions } = this.props;
        actions.updateEntity(entity_details.active_entity_data.entity, this.goToEntitiesPage);
    };

    onErrorCallback = () => {
        showMessage('error', 'something went wrong.');
        this.goToEntitiesPage();
    };

    render() {
        const { entity_details, page_details, actions } = this.props;

        if (entity_details.loaders.entity_data_loading && !entity_details.loaders.entity_data_loaded) {
            return (
                <Row>
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <Col xs={24} sm={{ span: 18, offset: 3 }} md={{ span: 16, offset: 4 }} className="ori-t-pad-15">
                        <CardRowTableLoader />
                    </Col>
                </Row>
            );
        } else if (!entity_details.loaders.entity_data_loading && entity_details.loaders.entity_data_loaded) {
            if (entity_details.active_entity_data.entity && entity_details.active_entity_data.entity.type && entity_details.active_entity_data.entity.type === ENTITY_TYPES.SIMPLE) {
                return (
                    <ErrorBoundary onErrorCallback={this.onErrorCallback}>
                        <SimpleEntity entity_details={entity_details} page_details={page_details} actions={actions} updateEntity={this.updateEntity} goToEntitiesPage={this.goToEntitiesPage} />
                    </ErrorBoundary>
                );
            } else if (entity_details.active_entity_data.entity && entity_details.active_entity_data.entity.type && entity_details.active_entity_data.entity.type === ENTITY_TYPES.HIERARCHICAL) {
                return (
                    <ErrorBoundary onErrorCallback={this.onErrorCallback}>
                        <HierarchicalEntity entity_details={entity_details} page_details={page_details} actions={actions} updateEntity={this.updateEntity} goToEntitiesPage={this.goToEntitiesPage} />
                    </ErrorBoundary>
                );
            } else if (entity_details.active_entity_data.entity && entity_details.active_entity_data.entity.type && entity_details.active_entity_data.entity.type === ENTITY_TYPES.LIST) {
                return (
                    <ErrorBoundary onErrorCallback={this.onErrorCallback}>
                        <ListEntity entity_details={entity_details} page_details={page_details} actions={actions} updateEntity={this.updateEntity} goToEntitiesPage={this.goToEntitiesPage} />
                    </ErrorBoundary>
                );
            } else {
                return (
                    <ShowMessage error title="Error" message="Entity type is unknown or undefined" height={150} width={150} show_button handleButtonClick={this.goToEntitiesPage} />
                );
            }
        } else if (!entity_details.loaders.entity_data_loading && !entity_details.loaders.entity_data_loaded) {
            return (
                <ShowMessage title="Error" message="unable to load entity data. please check your internet connection and reload the page." height={150} width={150} error />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        entity_details: state.entity_details,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, entityActions), dispatch)
    };
}

EditEntity.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    entity_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EditEntity);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/entities/editentity/index.js